<template>
  <CustomPicker
    :isInDialog="isInDialog"
    :multiple="multiple"
    title="fullName"
    :inputLabel="inputLabel"
    v-model="selectedUser"
    :items="usersList"
    :closeOnSelect="multiple ? false : true"
    @search="handleSearch"
  >
    <template #labelOption="option">
      <span dir="rtl" style="text-align: right">
        {{ option.item.fullName }}
        <template v-if="option.item.mobile">
          ({{ option.item.mobile }})
        </template>
      </span>
    </template>
  </CustomPicker>
</template>
<script>
export default {
  emits: ["getUser"],
  props: {
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    defaultSelectedUser: {
      type: Object,
      default: null,
    },
    isInDialog: {
      type: Boolean,
      default: false,
    },
    inputLabel: {
      type: String,
      default: "کاربر را انتخاب کنید",
    },
  },
  mounted() {
    this.getAllUsersList();
  },
  watch: {
    selectedUser: {
      handler(val) {
        if (this.multiple) {
          this.$emit("getUser", val || null);
        } else {
          this.$emit("getUser", val?.userId || null);
        }
      },
    },
    defaultSelectedUser: {
      handler(val) {
        if (val) {
          this.selectedUser = val;
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      usersList: null,
      selectedUser: null,
      searchVal: null,
      timeout: null,
    };
  },
  methods: {
    handleSearch(searchValue, loadingFn) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(async () => {
        this.searchVal = searchValue;
        loadingFn(true);
        await this.getAllUsersList();
        loadingFn(false);
      }, 300);
    },
    async getAllUsersList() {
      try {
        let reqParams = {
          count: 10,
          pageNumber: 1,
        };
        if (this.searchVal && this.searchVal != "") {
          reqParams["fullname"] = this.searchVal;
        }
        let _this = this;
        let getAllUsersList = new GetAllUsersList(_this);
        getAllUsersList.setRequestParamDataObj(reqParams);
        await getAllUsersList.fetch((response) => {
          if (response.isSuccess) {
            _this.usersList = response.data.users;
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
  components: {
    CustomPicker,
  },
};
import CustomPicker from "@/views/components/Utils/CustomPicker.vue";
import { GetAllUsersList } from "@/libs/Api/Users";
</script>
